import { render } from "./EditPoint.vue?vue&type=template&id=75b1fc54&scoped=true"
import script from "./EditPoint.vue?vue&type=script&lang=js"
export * from "./EditPoint.vue?vue&type=script&lang=js"

import "./EditPoint.vue?vue&type=style&index=0&id=75b1fc54&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b1fc54"]])

export default __exports__